import ProfilePicture from '@/components/ProfilePicture'
import OnboardingLayout from '@/components/layout/OnboardingLayout'
import { useAppStore } from '@/store'
import { useTranslation } from '@/i18n'

const AccountDetails = () => {
  const { t } = useTranslation()
  const { user } = useAppStore()

  return (
    <OnboardingLayout>
      <div className="w-[60%] h-full flex justify-center flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h2 className="font-bold text-2xl text-gray-600 dark:text-gray-400">
            {t('account:onboarding.organization_details')}
          </h2>
        </div>
        <div className="flex flex-col">
          <div className="flex items-center gap-3">
            <ProfilePicture user={user} />
            <div className="flex flex-col">
              <h4 className="text-xl">{user?.name}</h4>
              <span className="text-md text-gray-500 dark:text-dark-text-muted">{user?.email}</span>
            </div>
          </div>
        </div>
        <p className="text-gray-500 dark:text-dark-text-muted text-lg">
          {t('account:onboarding.organization_setup_success')}
        </p>

        <div className="bg-white dark:bg-dark-card p-6 rounded-lg border border-gray-200 dark:border-dark-border">
          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
              {t('account:onboarding.organization_status')}
            </label>
            <div className="text-lg text-gray-900 dark:text-dark-text">{t('account:onboarding.status_active')}</div>
          </div>
        </div>
      </div>
    </OnboardingLayout>
  )
}

export default AccountDetails

